export default __webpack_public_path__ + "static/media/hn.442fad0c.png";